<h2 nz-title class="section-header">My Cart</h2>
<div [ngClass]="{'card': !detailed}" [@.disabled]="isE2E">
  <div *ngIf="!detailed" class="card-header">
  </div>
  <!--There is no CSS for "order-summary". Its required as tests are dependent on it-->
  <div class="card-body bg-white order-summary"
       [style.padding]="!detailed ? '12px' : '0'"
       [@updatedCart]="cartUpdatedState && !detailed"
       (@updatedCart.done)="endAnimation($event)">

    <span *ngIf="isCartEmpty; else displayCart">{{emptyCartMessage}}</span>

    <ng-template #displayCart>
      <div class="container grey-border bg-light-grey order-summary_group-container"
           *ngFor="let group of (groups$ | async); let last=last">
        <div class="order-summary_group">
          <app-cart-manage-sampling [group]="group"></app-cart-manage-sampling>
          <app-cart-item
              *ngFor="let cartItem of group.items; let last=last"
              [groupId]="group.id"
              [type]="getCartItemType(cartItem.resourceType)"
              [cartSampling]="getCartSampling(group)"
              [cartItem]="cartItem"
              [last]="last"
              [unavailableItemsPresent]="group.unavailableItems.length > 0"
              [detailed]="detailed"
              (showDetail)="createComponentModal($event)">
          </app-cart-item>
          <app-unavailable-cart-item
                                     *ngFor="let unavailCartItem of group.unavailableItems; let last=last"
                                     [cartItem]="unavailCartItem"
                                     [groupType]="getCartItemType(group.resourceType)"
                                     [cartSampling]="getCartSampling(group)"
                                     [detailed]="false"
                                     [last]="last">
          </app-unavailable-cart-item>
        </div>
      </div>

      <hr class="light-hr">
      <p class="grand-total"
         style="text-align: right"
         [ngClass]="{'detailed-total': detailed}">TOTAL:
        <span id="grandTotal"
              style="text-align: right; padding-right: 2px"
              [ngClass]="{'detailed-total': detailed}"
              [@updatedCart]="cartPriceUpdate && detailed"
              (@updatedCart.done)="endAnimation($event)">
          {{(cart | async).cartPrice?.amount | currency:'NZD':'symbol-narrow'}}
        </span>  excl. GST</p>
      <hr class="dark-hr" [ngClass]="{'d-md-none': detailed}">
      <div>
        <button nz-button
                [ngClass]="{'checkout': detailed,
                            'ft-13': !detailed}"
                (click)="viewCartOrCheckout()">
          {{detailed ? 'CHECKOUT':'VIEW CART'}}
        </button>
      </div>
      <div  *ngIf="showClearCartButton && !detailed">
        <button nz-button
          [ngClass]="{'checkout': detailed }"
          (click)="renewCart()">
          CLEAR CART
        </button>
      </div>
    </ng-template>
  </div>
</div>
